import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { LookupTable } from '../components/LookupTable';
import { InsuranceCompanyTable } from '../components/InsuranceCompanyTable';
import { usePageTitle } from '@/hooks/usePageTitle';
import { LOOKUP_TYPE_CONFIGS, type LookupType } from '../types/lookup';

/**
 * Main page for managing lookup tables
 * Displays tabs for each lookup type (Damage Types, Referral Types, etc.)
 */
export function LookupsPage() {
  usePageTitle('Lookup Tables');
  const [activeTab, setActiveTab] = useState<LookupType>('damage-types');

  return (
    <div className="min-h-screen bg-background px-5 py-6">
      <div className="container mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-secondary">Lookup Tables</h1>
          <p className="text-muted-foreground mt-1">
            Manage dropdown options used throughout the system
          </p>
        </div>

        {/* Tabs */}
        <Tabs value={activeTab} onValueChange={(value) => setActiveTab(value as LookupType)}>
          <TabsList className="mb-4">
            {LOOKUP_TYPE_CONFIGS.map((config) => (
              <TabsTrigger key={config.type} value={config.type}>
                {config.label}
              </TabsTrigger>
            ))}
          </TabsList>

          {LOOKUP_TYPE_CONFIGS.map((config) => (
            <TabsContent key={config.type} value={config.type}>
              {config.type === 'insurance-companies' ? (
                <InsuranceCompanyTable />
              ) : (
                <LookupTable lookupType={config.type} title={config.label} />
              )}
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
